import { theme } from "antd";
import { GaugeMetric } from "./GaugeMetric";

export enum UrgencyType {
  critical = "critical",
  high = "high",
  important = "important",
  "nice to have" = "nice to have",
}

export enum ImpactType {
  high = "high",
  elevated = "elevated",
  moderate = "moderate",
  minimal = "minimal",
  low = "low",
}
export function Urgency(props: { value: UrgencyType; explanation: string }) {
  const { token } = theme.useToken();
  return (
    <GaugeMetric
      value={props.value}
      explanation={props.explanation}
      data={[
        { name: UrgencyType["nice to have"], value: 1, color: token.green },
        { name: UrgencyType.important, value: 1, color: token.yellow },
        { name: UrgencyType.high, value: 1, color: token.orange },
        { name: UrgencyType.critical, value: 1, color: token.red },
      ]}
    />
  );
}
